module.exports = __webpack_public_path__ + "assets/img/image-55-320.1c817eb7.webp";